
export const isLocalHost = document.location.host.split(':').shift() === 'localhost'